import React, { PureComponent } from 'react';
import styles from './Stars.css';

import SectionTitle from '../../components/SectionTitle';
import StarBlockComponent from '../../components/StarBlock';
import BitBackground from '../../components/BitBackground';
import container from './container';
import { gcpURL } from '../../lib/utils';

const icon = `${gcpURL}/static/ic-star.svg`;
const star1 = `${gcpURL}/static/1_artist.jpg`;
const star2 = `${gcpURL}/static/2_artist.jpg`;
const star3 = `${gcpURL}/static/3_artist.jpg`;
const star4 = `${gcpURL}/static/4_artist.jpg`;
const star5 = `${gcpURL}/static/5_artist.jpg`;
const star6 = `${gcpURL}/static/6_artist.jpg`;
const star7 = `${gcpURL}/static/7_artist.jpg`;
const star8 = `${gcpURL}/static/8_artist.jpg`;
const star9 = `${gcpURL}/static/9_artist.jpg`;
const star10 = `${gcpURL}/static/10_artist.jpg`;
const star11 = `${gcpURL}/static/11_artist.jpg`;
const star12 = `${gcpURL}/static/12_artist.jpg`;
const star13 = `${gcpURL}/static/13_artist.jpg`;
const star14 = `${gcpURL}/static/14_artist.jpg`;
const star15 = `${gcpURL}/static/15_artist.jpg`;
const star16 = `${gcpURL}/static/16_artist.jpg`;
const star17 = `${gcpURL}/static/17_artist.jpg`;
const star18 = `${gcpURL}/static/18_artist.jpg`;
const star19 = `${gcpURL}/static/19_artist.jpg`;
const star20 = `${gcpURL}/static/20_artist.jpg`;
const star21 = `${gcpURL}/static/21_artist.jpg`;

const IconLeft = `${gcpURL}/static/ig-star-line-left.svg`;
const IconRight = `${gcpURL}/static/ig-star-line-right.svg`;

const stars = [
  {
    name: '陶晶瑩',
    pic: star1,
    info: '陶晶瑩（英語：Matilda Tao，1969年10月29日－），暱稱陶子，畢業於臺北市立中山女子高級中學、國立政治大學新聞學系。是臺灣著名電視節目女主持人、歌手、作家、經紀人及姊妹淘網站總編輯。',
  },
  {
    name: '納豆',
    pic: star2,
    info: '林郁智（1981年1月7日－），藝名納豆，跨足綜藝、主持、戲劇、電影的全方位男藝人。2013年9月26日和主持搭檔任家萱（Selina）以《小宇宙33號》首次入圍第48屆金鐘獎綜藝節目主持人獎。2016年以公路電影《一路順風》入圍第53屆金馬獎最佳男配角奬。',
  },
  {
    name: '瑪麗',
    pic: star3,
    info: '吳瑪麗（1982年7月19日－），藝名瑪麗，本名吳宜媚，2004年透過徵選加入飛碟電台擔任DJ，主持深夜節目青春點點點（2004年10月17日─2017年3月7日），自此展開廣播生涯。其主持風格搞笑、無厘頭，因而擁有不少忠實聽眾。另活躍於專欄創作、綜藝節目、網路直播以及活動主持等領域。',
  },
  {
    name: '路嘉怡',
    pic: star4,
    info: '路嘉怡，台灣知名節目主持人，人稱小米，因主持時尚流行與彩妝節目而聞名，有生活時尚教主之稱。',
  },
  {
    name: '劉容嘉',
    pic: star5,
    info: '容嘉，崇尚自然養生並兼具時尚之主持人、演員及歌手。擁有個人專輯[我的自卑感]，並參與多部偶像劇及電影之演出，擔任音樂、旅遊、時尚節目及各知名品牌活動及記者會主持。於2016年主持17直播主辦之[超強17練習生]及[網路熱容佼]、[美食大玖嘉]，主持領域多元，深受觀眾喜愛。 ',
  },
  {
    name: 'EXID',
    isEng: true,
    pic: star6,
    isCenter: true,
    info: '集合少女的純真和女人的性感，韓國女子團體EXID由五位平均年齡22歲的女孩所組成，分別為率智、LE 、哈妮、惠璘和靜花。2014年底靠著〈Up & Down〉洗腦神曲，逆襲韓國及台灣各大音榜，後續推出一系列膾炙人口的熱門舞曲，搶佔國內外音源排行榜！2017年3月再度推出第三張迷你專輯《Eclipse》，音樂的多風格和團員的創作、歌喉、舞技，都再再證明她們的成功並非偶然，實力、努力、魅力皆不容小覷也不容質疑！',
  },
  {
    name: 'Crayon Pop',
    isEng: true,
    pic: star7,
    isCenter: true,
    info: '不玩性感、不搞煽情，也能很Fashion！紅遍國際的最萌女子團體Crayon Pop以「汽缸舞」神曲《Bar Bar Bar》成為韓樂黑馬，Crayon Pop由GumMi、Ellin、SoYul、ChoA與Way組成，自2012年出道以來，不跟隨其他韓國女子團體以性感火辣與結合唱跳的主流包裝，以簡單復古的歌曲、樸實另類的造型及趣味俏皮的舞蹈建立絕無僅有的形象。〈Bar Bar Bar〉以「運動服＋白手套＋安全帽」的裝扮及俏皮逗趣的「汽缸舞」，成功吸引全球關注目光，掀起連串的模仿潮。',
  },
  {
    name: 'A-LIN',
    isEng: true,
    pic: star10,
    info: 'A-Lin（阿美語：Lisang Pacidal Koyouan）臺灣著名女歌手，封號為「天生歌姬」，是臺東阿美族原住民，出生於高雄苓雅區。其演唱技巧優秀，嗓音渾厚磁性，音域寬廣和現場演唱與錄音水準一樣，是臺灣女版「零瑕疵」歌手，為臺灣著名的實力派歌手，曾數次入圍臺灣金曲獎，並多次受邀在重要的頒獎典禮上獻唱。',
  },
  {
    name: '王陽明',
    pic: star8,
    info: '王陽明，男演員. 在美國東岸的紐澤西以及紐約長大. 畢業於紐約大學史登商學院，主修行銷以及輔修電影製作. 2011年演出偶像電視劇《我可能不會愛你》而廣為人知，2015年參與電影《角頭》票房與演技都大獲好評，近期作品為陸劇《追婚記》以及《那片星空那片海》電影《賽鴿探戈》',
  },
  {
    name: 'Dizzy Dizzo',
    isEng: true,
    pic: star9,
    info: 'Dizzy Dizzo 蔡詩芸，女歌手，出生於澳洲。蔡詩芸19歲來到台北出個人首張專輯「紫外線」。在2014年，蔡詩芸幫自己的音樂身分創造了一個名字叫「Dizzy Dizzo 」也推出了首張同名英文EP。2016年出了屬於Dizzy Dizzo的首張專輯「骨子裏」得到不少的好評論。',
  },
  {
    name: 'Roger',
    isEng: true,
    pic: star16,
    info: 'Roger（鄭健國），亞洲著名頂級造型、彩妝大師。至今在業界已累積超過30年的豐富資歷，除了深受名人藝人的愛戴之外，更是各大時尚精品爭相合作的對象，已成為無可取代的時尚指標性人物。',
  },
  {
    name: '江美琪',
    pic: star12,
    info: '江美琪首張專輯「我愛王菲」發行後，業界評價極高，特別是江美琪清亮、高亢的嗓音備受矚目。專輯中音階跨度極大的歌曲《鏡子聯想曲》更是完美體現了江美琪「一鳴驚人」的強力唱功。相隔半年後，於同年底發行第二張專輯「第二眼美女」，次年入圍金曲獎「最佳新人」。',
  },
  {
    name: 'Joanna',
    isEng: true,
    pic: star13,
    info: '王若琳（Joanna Wang）創作歌手∕製作人，1988年8月1日出生,因其在美國成長的背景,歌曲多為全英文創作,擅長異想天開、黑暗和古怪的音樂,深受Queen、The Beatles、Lemon Demon、Danny Elfman及Oingo Boingo的影響。',
  },
  {
    name: '艾怡良',
    pic: star14,
    info: '艾怡良，高辨識度的嗓音及跳脫框架的創作，總是帶給我們無法預料的驚艷。台灣樂壇少見橫跨商業與文青市場的唱將型創作歌手，豐沛的創作力與詮釋歌曲獨特的口氣，都讓歌迷們看見她的無限潛能。',
  },
  {
    name: 'J.Sheon',
    isEng: true,
    pic: star15,
    info: '2017萬眾期待的饒舌界新人，能惡搞也能動人的超強實力，要你迷上饒舌，了解更多！煮菜超強 · 愛吃水餃 · 甩鍋一哥 · 愛貓暖男。',
  },
  {
    name: 'Matzka',
    isEng: true,
    pic: star11,
    info: 'MATZKA為台灣音樂創作人、製作人，其音樂風格以雷鬼為主，並混合爵士樂、民謠、重金屬、Rap和嘻哈等元素，來自台東的原住民，其曲風也帶有濃厚的原住民風格。',
  },
  {
    name: 'Lulu',
    isEng: true,
    pic: star17,
    info: '演藝界新生代最有潛力女主持人,個性活潑、具親和力，主持過的節目有「綜藝大熱門」、「完全娛樂」 …...等，主持台風穩健幽默有趣，為史上最年輕金鐘獎綜藝節目主持人入圍者。2016 年主持金曲獎星光大道除好評不斷外，更擔任典禮內暖場主持，被網友喻為神暖場，韓星見面會更是相爭邀請女主持之一。愛唱歌的她，也發行過個人首張 EP 「LuLu，腿」，舉辦個人首場 Legacy 售票演唱會。',
  },
  {
    name: '蔡淑臻',
    pic: star18,
    info: '伊林娛樂旗下藝人。從名模轉戰演員後，曾獲金鐘獎最佳戲劇節目女配角及女主角提名，活躍於時尚、戲劇、電影等演出工作。',
  },
  {
    name: '劉以豪',
    pic: star19,
    info: '伊林娛樂旗下藝人。2008年進入演藝圈。模特兒時期拍過多支令人印象深刻的電視與平面廣告作品，2011年在《我可能不會愛你》飾演趙美男嶄露頭角，靠著招牌花椰菜頭和燦爛笑容，迅速打開知名度。他被稱是花椰菜村的「村長」，粉絲是「村民。近幾年擔綱主演的電視劇與電影，皆引發熱烈討論。2016年榮獲首爾國際電視節 亞洲之星獎項。超強話題力！超過90萬粉絲大軍，隨時有近20萬人在線上討論【劉以豪】！',
  },
  {
    name: '賴琳恩',
    pic: star20,
    info: '伊林娛樂旗下藝人。外型甜美性感，擁有一雙修長的美腿以及一副迷人電眼。2008年拿下港姐季軍後一炮而紅，並積極開始戲劇演出，廣告代言邀約不斷。',
  },
  {
    name: '黃志瑋',
    pic: star21,
    info: '伊林娛樂旗下藝人。2002年獲得模特兒大賽冠軍後，就經常受邀為各大名牌的時裝走秀，以及商品發表會。進而知名度大開，節目與戲劇廣告邀約不斷，也跨足主持綜藝、舞台劇。',
  },
];

class Stars extends PureComponent {
  state = {
    expand: 0,
  };

  handleExpand = (target) => () => {
    this.setState(({ expand }) => ({ expand: expand === target ? 0 : target }));
  }

  render() {
    const { expand } = this.state;

    const StarBlock = container(StarBlockComponent, {
      handleExpand: this.handleExpand,
      expand,
    });

    return (
      <section className={styles.stars}>
        <div className="container">
          <SectionTitle title="星光雲集" icon={icon} />

          <div className={styles.starList}>
            {stars.map((star, i) => (
              <StarBlock
                className={styles.starBlock}
                index={i + 1}
                key={i}
                {...star}
                info={star.info || 'test'}
              />
            ))}

            <img className={styles.bgIconLeft} src={IconLeft} />
            <img className={styles.bgIconRight} src={IconRight} />
          </div>
        </div>

        <BitBackground className={styles.bitBackground} />
      </section>
    );
  }
}

export default Stars;



// WEBPACK FOOTER //
// ./src/sections/Stars/index.js